// webapp/src/lib/ipscParticipant.js
//
// IPSC participant helpers shared by signup, the participant drawer and the
// kanban: normalise what a shooter picked (division/PF/category) and tell the
// UI whether a convention / Lag is IPSC. Pure, no stores.

import { isValidDivision, isValidCategory, divisionAllowsMajor } from './ipsc';

export function isIpscConvention(convention) {
    return !!(convention && convention.type === 'ipsc');
}

export function isIpscStage(stage) {
    return !!(stage && stage.type === 'ipsc');
}

// Normalise a signup/entry: unknown division or category → '', PF → 'minor' unless
// 'major' is both requested and allowed in the division.
export function ipscParticipantFromSignup(entry = {}) {
    const division = isValidDivision(entry.class) ? entry.class : '';
    const powerFactor = entry.powerFactor === 'major' && divisionAllowsMajor(division) ? 'major' : 'minor';
    const ipscCategory = isValidCategory(entry.ipscCategory) ? entry.ipscCategory : '';
    return { class: division, powerFactor, ipscCategory };
}

// The IPSC keys to copy from a convention-level participants[] entry onto the
// squad (participantsN) entry when the stevneleder places the shooter.
export function ipscEntryFields(entry = {}) {
    const n = ipscParticipantFromSignup(entry);
    return { powerFactor: n.powerFactor, ipscCategory: n.ipscCategory };
}

// A squad entry can only be scored once it has a valid division (an entry placed
// without one would produce an op keyed on 'undefined' that can never sync).
export function canScoreEntry(entry = {}) {
    return !!(entry && entry.id && isValidDivision(entry.class));
}
